import { MainService } from 'src/app/Services/service.service';
import { FormBuilder } from '@angular/forms';
import { RegisterComponent } from './../../../User/register/register.component';
import { Component, OnInit } from '@angular/core';
import {Location} from '@angular/common';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.scss']
})
export class RegistrationComponent extends RegisterComponent {

  public enablePhoneRegConfirm:boolean = false;

  successRegister: boolean = false;
  public loading: boolean = false;

  constructor(private _location: Location, fb: FormBuilder, private service: MainService) {
    super(fb, service, null);
    
    this.enablePhoneRegConfirm = service.enablePhoneRegConfirm;
   }

  onSubmit() {
    this.validateAllFormFields(this.registrationForm);
    if (!this.registrationForm.invalid) {
      if (!this.isCaptchaOk()) {
        this.services.showError("Please confirm the captcha");
      }else{
        this.loading = true;
        this.service.userService
          .register(this.registrationForm.controls["email"].value, this.registrationForm.controls["phone"].value, this.registrationForm.controls["password"].value, this.registrationForm.controls["passwordConfirm"].value, "registration-success")
          .then(r => {
            this.successRegister = true;
            setTimeout(() => { 
              this.service.route.navigate(["/"]);
              this.loading = false;
            }, 2000);
            
          })
          .catch(e => {
            this.loading = false;
            this.service.showError(e);
          });
        }
    }
  }

  

  locationBack() {
    this._location.back();
  }

}
